import { render, staticRenderFns } from "./NewTextPost.vue?vue&type=template&id=bc7c73da&scoped=true"
import script from "./NewTextPost.vue?vue&type=script&lang=js"
export * from "./NewTextPost.vue?vue&type=script&lang=js"
import style0 from "./NewTextPost.vue?vue&type=style&index=0&id=bc7c73da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7c73da",
  null
  
)

export default component.exports